import axios from 'axios';
import apiConfig from '../../api.config';

export default async function sendOptIn(hotelId, atlasID, product, clientId, IHClientId) {
  const {
    host,
    URIs: { hbxOptIn },
  } = apiConfig;

  const data = {
    hotelId,
    atlasID,
    product,
    clientId,
    IHClientId,
  };

  const uri = `${host}${hbxOptIn}`;

  return await axios.post(uri, data).then(res => res.data);
}
